import { useState } from "react"

type StorageValue = any;

export default function useStorage<T extends StorageValue>(key:string, type:"local"|"session" = "local", initialValue:T = undefined as T){
    const storage = type==="local"?localStorage:sessionStorage;

    const [value, setValue] = useState<T>(()=>{
        const item = storage.getItem(key);

        if(item === null){
            if(initialValue === undefined){
                return undefined;
            }else{
                storage.setItem(key, JSON.stringify(initialValue));
                return initialValue;
            }
        }else{
            return JSON.parse(item);
        }
    });

    const handleSetValue = (value:StorageValue)=>{
        if(value === undefined){
            storage.removeItem(key);
        }else{
            storage.setItem(key, JSON.stringify(value));
        }

        setValue(value);
    }

    return [value, handleSetValue] as [T, (value:T)=>void];
}